import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Stack, Button, Thumbnail, Caption } from '@shopify/polaris';
import { DeleteMajorMonotone } from '@shopify/polaris-icons';

const propTypes = {
  onClick: PropTypes.func,
  onDelete: PropTypes.func,

  url: PropTypes.string.isRequired,
  filename: PropTypes.string,
  size: PropTypes.number,
  sizeUnit: PropTypes.string,
  disabled: PropTypes.bool
};

const defaultProps = {
  sizeUnit: "bytes"
}


const ImageStackItem = (props) => (
  <Stack 
    wrap={false}
    alignment="center">
    <Stack.Item>
      <Button 
        onClick={ props.onClick }
        outline
      >
          <Thumbnail
            size="medium"
            alt={ props.filename }
            source={ props.url }
          />
      </Button>
    </Stack.Item>

    <Stack.Item fill>
      { props.filename } 
      { !!props.size &&
        <Caption>{ props.size } { props.size_unit }</Caption>
      }
    </Stack.Item>

    { !!props.onDelete &&
      <Stack.Item>
        <Button
          plain destructive
          icon={ DeleteMajorMonotone }
          onClick={ props.onDelete  }
          disabled={ props.disabled }
        />
      </Stack.Item>
    }
  </Stack>
)

ImageStackItem.propTypes = propTypes;
ImageStackItem.defaultProps = defaultProps;

export default ImageStackItem;